import ApiService from '@/data/services/ApiService'
import { ITest } from '@/data/models/Test'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class DiagnosticGroupsApiService extends ApiService {
  /**
   * Returns paginated list of DiagnosticGroups
   */
  static async getAll(): Promise<IServiceResponse<ITest>> {
    return this.axios.get('diagnostic-groups')
      .then((response: AxiosResponse<IServiceResponse<ITest>>) => response.data)
  }
}
